import { useCallback } from 'react';
import api from '@/lib/api';
import useDiscountsLogic from '@/shared/checkout/useDiscountsLogic';

/**
 * Wrapper CRM do `useDiscountsLogic` partilhado — apenas injecta os endpoints
 * `/api/encomendas/*`. Toda a lógica está em
 * `/app/frontend/src/shared/checkout/useDiscountsLogic.js` (partilhado com o
 * MY checkout).
 */
export default function useDiscounts({ selectedTransport, selectedPayment, selectedEnvio }) {
  const loadBalances = useCallback(async () => {
    const r = await api.get('/encomendas/balances');
    return { vouchers: Number(r.data?.vouchers || 0), credits: Number(r.data?.credits || 0) };
  }, []);

  const verifyPromo = useCallback(async (code, { appliedVales, appliedCreditos }) => {
    const { data } = await api.post('/encomendas/verify', {
      id_tipo_transporte: selectedTransport,
      id_tipo_pagamento: selectedPayment || '',
      id_morada_envio: selectedEnvio,
      desconto_creditos: appliedCreditos,
      desconto_vale: appliedVales,
      codigo_promocional: code,
    });
    return data?.data?.[0] || null;
  }, [selectedTransport, selectedPayment, selectedEnvio]);

  const prerequisitesValid = useCallback(
    () => Boolean(selectedTransport && selectedEnvio),
    [selectedTransport, selectedEnvio],
  );

  return useDiscountsLogic({ loadBalances, verifyPromo, prerequisitesValid });
}
